import { useEffect, useState } from 'react';
import { fetchObjectsFromUrls } from 'rest/object-resolver-service';
import batch from '@atlassian/help-center-common-util/batch-function';

export const fetchIcons = (urls: string[]) => {
	return fetchObjectsFromUrls(urls)
		.toPromise()
		.then((response) => {
			return urls.reduce(
				(ref, url, index) => ({
					...ref,

					// Suppressing existing violation. Please fix this.
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
					[url]: response[index],
				}),
				{},
			);
		});
};
const batchedFetchIcon = batch(fetchIcons, 0);

// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// eslint-disable-next-line @typescript-eslint/ban-types
export const iconCache: { string: string } | {} = {};
const addIconToCache = (key: string, value: string | null) => {
	// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
	iconCache[key] = value;
};

export function useExternalLinkIcon({
	isLoggedIn,
	link: url,
}: {
	link: string;
	isLoggedIn: boolean;
}) {
	const [data, setData] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const markDataLoaded = (key: string, value: string | null) => {
		setIsLoading(false);
		setData(value);
		addIconToCache(key, value);
	};

	useEffect(() => {
		let href = url;

		if (!isLoggedIn) {
			markDataLoaded(url, null);
			return;
		}

		/**
		 * Try to parse the url and extract out the href
		 * if it fails return null as the icon url
		 */
		try {
			href = new URL(url).href;
		} catch (error) {
			markDataLoaded(url, null);
			return;
		}

		/**
		 * Origin is null for other supported url forms like `tel:` and `mail:`
		 * return null so that ui can fallback to default icons
		 */

		if (new URL(url).origin === 'null') {
			markDataLoaded(url, null);
			return;
		}

		/**
		 * check is there is already entry in cache
		 * if yes, return the icon url
		 * else, make a call to object resolver service
		 */
		if (Object.keys(iconCache).includes(href)) {
			// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
			// Suppressing existing violation. Please fix this.
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			const iconUrl = iconCache[href];
			setData(iconUrl);
			setIsLoading(false);
		} else {
			batchedFetchIcon(href)
				.then((response) => {
					// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
					// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
					// Suppressing existing violation. Please fix this.
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
					const iconUrl = response[href]?.body?.data?.generator?.icon?.url;

					markDataLoaded(href, iconUrl ?? null);
				})
				.catch(() => {
					return null;
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, [isLoggedIn, url]);

	return {
		data,
		isLoading,
	};
}
